var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { default as UiSelect, CreatableSelect as UiCreatableSelect, } from "@atlaskit/select";
import Field from "../../templates/Field";
export default React.forwardRef(function (props, ref) {
    var value = props.value, isCreateable = props.isCreateable, isDisabled = props.isDisabled, label = props.label, initialOptions = props.options, error = props.error, onChangeInput = props.onChangeInput, rest = __rest(props, ["value", "isCreateable", "isDisabled", "label", "options", "error", "onChangeInput"]);
    var _a = React.useState(initialOptions), options = _a[0], setOptions = _a[1];
    var _b = React.useState(""), search = _b[0], setSearch = _b[1];
    var onChange = function (value) {
        var name = props.name;
        var newValue = value ? __spreadArray([], value, true) : [];
        props.onChange && props.onChange(name, newValue);
    };
    var onBlur = function (e) {
        var name = props.name;
        // @ts-ignore - propably due to atlaskit
        var value = e.target.value || "";
        props.onBlur && props.onBlur(name, value);
    };
    var onCreateOption = function (value) {
        if (value) {
            var option = { value: value, label: value };
            setOptions(__spreadArray(__spreadArray([], options, true), [option], false));
            onChange(__spreadArray(__spreadArray([], props.value, true), [option], false));
        }
    };
    var onChangeSearchInput = function (value) {
        setSearch(value);
    };
    React.useEffect(function () {
        setOptions(initialOptions);
    }, [initialOptions]);
    React.useEffect(function () {
        if (search) {
            var timeoutId_1 = setTimeout(function () { return onChangeInput && onChangeInput(props.name, search); }, 500);
            return function () { return clearTimeout(timeoutId_1); };
        }
        // eslint-disable-next-line
    }, [search]);
    // Extend options by value
    var newOptions = options;
    var isValueInOptions = options.filter(function (value) {
        return props.value.map(function (v) { return v.value; }).includes(value.value);
    });
    if (!isValueInOptions) {
        newOptions = __spreadArray(__spreadArray([], options, true), props.value, true);
    }
    var styles = {
        // this fixes an issue where selects would be hidden within a modal,
        // src: https://codesandbox.io/s/c6j9hv?module=/example.tsx&file=/example.tsx:222-261
        menuPortal: function (base) { return (__assign(__assign({}, base), { zIndex: 9999 })); },
        control: function (base) { return (__assign(__assign({}, base), { 
            // FIXME: this is not the correct way to style the control element, it breaks focus styling
            borderColor: "rgb(223, 225, 230)", backgroundColor: "rgb(250, 251, 252)" })); }
    };
    return (_jsx(Field, __assign({ label: label, error: error }, { children: isCreateable ? (_jsx(UiCreatableSelect, __assign({}, rest, { isMulti: true, options: newOptions, value: props.value, onChange: function (value) {
                onChange(value);
            }, onBlur: onBlur, onCreateOption: onCreateOption, onInputChange: onChangeSearchInput, isClearable: false, menuPortalTarget: document.body, styles: styles }))) : (_jsx(UiSelect, __assign({}, rest, { isMulti: true, options: newOptions, value: props.value, onChange: function (value) {
                onChange(value);
            }, onBlur: onBlur, isClearable: false, onInputChange: onChangeSearchInput, menuPortalTarget: document.body, styles: styles }))) })));
});
//# sourceMappingURL=index.js.map